import Copy from "@components/global/new/Copy/Copy";
import SmallLink from "@components/global/new/SmallLink/SmallLink";
import { MODALS_ENUM } from "@constants/Modals";
import { RootDispatch } from "@store";
import cn from "classnames";
import { useIntl } from "react-intl";
import { useDispatch } from "react-redux";
import { Link as NavLink, useLocation } from "react-router-dom";
import { show } from "redux-modal";
//import { ReactComponent as Logo } from "../../assets/icons/logo.svg";
import { LocaleLangE } from "../../i18n/LocaleContext";
import Burger from "../global/Burger/Burger";
import styles from "./Layout.module.scss";
import { useHeaderControl } from "./userHeaderControl";
import { Badge, Popover, Radio } from "antd";

//icons
import notification from "@assets/redesign/icons/notification.svg";
import origUser from "@assets/redesign/icons/user.svg";
import wlpUser from "@components/WLP202603/assets/redesign/icons/user.svg";
import { useEffect, useState } from "react";
import MoscowTime from "./MoscowTime";
import RoleSwitcher from "./RoleSwitcher/RoleSwitcher";
import { WLP202603 } from "../../config";

type HeaderProps = {
  menu?: MenuItem[];
};

type MenuItem = {
  location?: string;
  id?: string;
  value?: string;
};

const user = WLP202603 ? wlpUser : origUser;

export default function Header(props: HeaderProps) {
  const { formatMessage } = useIntl();
  const dispatch = useDispatch() as RootDispatch;
  const control = useHeaderControl();
  const location = useLocation();
  const [title, setTitle] = useState("");
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (control.isLogon) {
      const item = props.menu?.find(
        (item) => item.location === location.pathname
      );
      setTitle(item?.id ? formatMessage({ id: item.id }) : item?.value || "");
    } else {
      setTitle("");
    }
  });

  return (
    <header className={cn(styles.header, { [styles.logon]: control.isLogon })}>
      {control.isLogon && (
        <div className={styles.title}>
          <h2>{title}</h2>
          <span>|</span>
          <MoscowTime />
        </div>
      )}
      <nav className={styles.nav}>
        {!control.isLogon && (
          <div className={styles.menuWrap}>
            <ul className={styles.menu}>
              <li>
                <NavLink to="/about">
                  {formatMessage({ id: "menu.about" })}
                </NavLink>
              </li>
              <li>
                <NavLink to="/location">
                  {formatMessage({ id: "menu.locations" })}
                </NavLink>
              </li>
              <li>
                <NavLink to="/transportation">
                  {formatMessage({ id: "menu.transportation" })}
                </NavLink>
              </li>
              <li>
                <NavLink to="/contacts">
                  {formatMessage({ id: "menu.contacts" })}
                </NavLink>
              </li>
              <li onClick={() => dispatch(show(MODALS_ENUM.CONTACT_US))}>
                {formatMessage({ id: "menu.call" })}
              </li>
              <li>
                <NavLink to="/contacts">
                  {formatMessage({ id: "menu.contacts" })}
                </NavLink>
              </li>
            </ul>
            <span>|</span>
            <MoscowTime />
          </div>
        )}
        <ul className={styles.menu}>
          {!control.isLogon && (
            <>
              <li>
                <NavLink to="/?signup">
                  {formatMessage({ id: "menu.sign" })}
                </NavLink>
              </li>
              <li>
                <NavLink to="/">{formatMessage({ id: "menu.login" })}</NavLink>
              </li>
            </>
          )}
          {control.showRoleSwithcher && (
            <li>
              <RoleSwitcher />
            </li>
          )}
          {control.isLogon && (
            <li className={styles.user}>
              <Popover
                placement="bottomRight"
                trigger="click"
                arrow={false}
                open={open}
                onOpenChange={setOpen}
                content={
                  <>
                    <div className={styles.acc_email}>
                      <p>{control.userEmail}</p>
                      <Copy text={control.userEmail} />
                    </div>
                    <div className={styles.content}>
                      <SmallLink
                        onClick={() => {
                          setOpen(false);
                          control.toAccount();
                        }}
                      >
                        {formatMessage({ id: "menu.login_account" })}
                      </SmallLink>
                      <SmallLink
                        onClick={() => {
                          setOpen(false);
                          control.logout("onClick logout");
                        }}
                      >
                        {formatMessage({ id: "menu.login_logout" })}
                      </SmallLink>
                    </div>
                  </>
                }
              >
                <img src={control.account?.avatar || user} alt="" />
              </Popover>
              {/*<Badge dot size='default'>
                <img src={notification} />
              </Badge>*/}
            </li>
          )}
          {!WLP202603 && (
            <li>
              <Radio.Group
                optionType="button"
                defaultValue={control.isRus ? LocaleLangE.RU : LocaleLangE.EN}
                className={styles.lang}
                onChange={(e) => control.setLocale(e.target.value)}
              >
                <Radio.Button value={LocaleLangE.EN}>Eng</Radio.Button>
                <Radio.Button value={LocaleLangE.RU}>Rus</Radio.Button>
              </Radio.Group>
            </li>
          )}
        </ul>
      </nav>
    </header>
  );
}
